import React, { ReactNode } from "react";
import { MultiSelect } from "primereact/multiselect";
export const FILTER_MAX_MULTISELECT_LABELS_TO_SHOW = 0;

export const MultiSelectTemplate = (
    options: any,
    filterOptions: string[],
    placeholder: string,
    dataCy: string
): ReactNode => {
    return (
        <MultiSelect
            value={options.value}
            data-cy={dataCy}
            options={filterOptions}
            onChange={(e) => options.filterApplyCallback(e.value)}
            placeholder={placeholder}
            className="p-column-filter"
            maxSelectedLabels={FILTER_MAX_MULTISELECT_LABELS_TO_SHOW}
            showClear
        />
    );
};
